import React, { Component } from "react";
import styled from "styled-components";
import {
  StyledStepNum,
  StyledTable
} from "./custom-styled-components/_MyCustomSC";
import MainContent from "./right-shipping-wrapper/MainContent";
import {} from "antd";

/**
 * @component
 * @category Form Page
 * @subcategory FCL Tab
 * @name RightShippingForm
 * @description It's the FCL shipping container component
 * <br> <br>
 * **Example**
 * ```js
 *   <RightShippingForm />
 * ```
 */
class RightShippingForm extends Component {
  render() {
    return (
      <div>
        <StyledTable>
          <tbody>
            <tr>
              <th>
                <StyledStepNum>1</StyledStepNum>
                <span style={{ fontWeight: 600 }}>What are you shipping?</span>
              </th>
            </tr>

            <tr>
              <td>
                <MainContent />
              </td>
            </tr>
          </tbody>
        </StyledTable>
      </div>
    );
  }
}
export default RightShippingForm;
